import { match } from 'ts-pattern'

export const underwritingStep = (platform: 'native' | 'web') =>
  match(platform)
    .with('native', () => 'dental_underwriting')
    .otherwise(() => 'underwriting_validation')
